export default "__VITE_ASSET__DGhak_sx__"